import { useState, useCallback } from 'react';
import type { StorageAdapter } from '../../adapters/types';
import type { BuildState } from '../../packs/types';

export interface FleetEntry {
  id: string;
  build: BuildState;
  hue: number;
  accentHue: number;
  glowHue: number;
  detailHue: number;
  trimHue: number;
  backgroundHue: number;
  primarySat: number;
  accentSat: number;
  glowSat: number;
  detailSat: number;
  trimSat: number;
  bgSat: number;
  borderEnabled: boolean;
  borderColor: string;
  savedAt: string;
}

const FLEET_KEY = 'undef-ship.fleet';

export function useFleet(storage: StorageAdapter) {
  const [fleet, setFleet] = useState<FleetEntry[]>([]);

  const load = useCallback(async () => {
    const raw = await storage.get(FLEET_KEY);
    if (!raw) return;
    try { setFleet(JSON.parse(raw)); } catch { /* corrupt */ }
  }, [storage]);

  const save = useCallback(async (entry: Omit<FleetEntry, 'id' | 'savedAt'>) => {
    const next: FleetEntry[] = [
      { ...entry, id: crypto.randomUUID(), savedAt: new Date().toISOString() },
      ...fleet,
    ].slice(0, 20);
    setFleet(next);
    await storage.set(FLEET_KEY, JSON.stringify(next));
  }, [fleet, storage]);

  const remove = useCallback(async (id: string) => {
    const next = fleet.filter(e => e.id !== id);
    setFleet(next);
    await storage.set(FLEET_KEY, JSON.stringify(next));
  }, [fleet, storage]);

  return { fleet, load, save, remove };
}
